'use client';

import React from 'react';

const activities = [
  {
    id: 1,
    type: 'visit',
    icon: '🗓',
    text: 'Visite planifiée — Zara Home @ Anfa',
    sub: 'Demain 10h00 · K. Alami',
    time: 'Il y a 12 min',
    color: 'bg-blue-100 text-blue-600',
  },
  {
    id: 2,
    type: 'match',
    icon: '⚡',
    text: 'Nouveau match 91% — McDonald\'s ↔ Blvd Mohammed V',
    sub: 'Score: 91% · Food & Beverage',
    time: 'Il y a 34 min',
    color: 'bg-green-100 text-green-600',
  },
  {
    id: 3,
    type: 'doc',
    icon: '📄',
    text: 'Document ajouté — Titre foncier Guéliz',
    sub: 'S. Benali · fiche #LOC-0247',
    time: 'Il y a 1h',
    color: 'bg-slate-100 text-slate-600',
  },
  {
    id: 4,
    type: 'status',
    icon: '✅',
    text: 'Statut mis à jour → En négociation',
    sub: 'Carrefour Express · Rue Liberté, Marrakech',
    time: 'Il y a 2h',
    color: 'bg-purple-100 text-purple-600',
  },
  {
    id: 5,
    type: 'new',
    icon: '🏢',
    text: 'Nouveau local ajouté — Hay Riad, Rabat',
    sub: '380 m² · Loyer 72 000 MAD · N. Tahiri',
    time: 'Il y a 3h',
    color: 'bg-amber-100 text-amber-600',
  },
  {
    id: 6,
    type: 'offer',
    icon: '📋',
    text: 'Offre reçue — Barid Bank @ Fès Centre',
    sub: 'Deal potentiel · M. Ouali',
    time: 'Hier 16h42',
    color: 'bg-emerald-100 text-emerald-600',
  },
  {
    id: 7,
    type: 'visit',
    icon: '👁',
    text: 'Visite réalisée — Pharmacie Centrale @ Anfa Place',
    sub: 'CR à rédiger · K. Alami',
    time: 'Hier 14h30',
    color: 'bg-blue-100 text-blue-600',
  },
  {
    id: 8,
    type: 'alert',
    icon: '⚠️',
    text: 'Alerte — Fiche incomplète depuis 32 jours',
    sub: 'LOC-0198 · Documents manquants',
    time: 'Hier 09h00',
    color: 'bg-red-100 text-red-600',
  },
];

export default function ActivityFeed() {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-card overflow-hidden h-full">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
        <div>
          <h3 className="text-base font-600 text-slate-900">Activité récente</h3>
          <p className="text-xs text-slate-400 mt-0.5">Dernières actions sur la plateforme</p>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <span className="text-xs text-slate-400">En direct</span>
        </div>
      </div>
      <div className="divide-y divide-slate-50 overflow-y-auto max-h-[360px] scrollbar-thin">
        {activities?.map(activity => (
          <div
            key={activity?.id}
            className="px-5 py-3.5 hover:bg-slate-50/60 transition-colors cursor-pointer"
          >
            <div className="flex items-start gap-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0 ${activity?.color}`}>
                {activity?.icon}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-500 text-slate-800 leading-snug">{activity?.text}</p>
                <p className="text-xs text-slate-400 mt-0.5">{activity?.sub}</p>
              </div>
              <span className="text-xs text-slate-400 flex-shrink-0 mt-0.5 whitespace-nowrap">{activity?.time}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="px-5 py-3 border-t border-slate-100">
        <a href="/activite" className="text-xs font-600 text-primary-700 hover:underline">
          Voir tout le journal d'activité →
        </a>
      </div>
    </div>
  );
}